/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AddOrRemoveModelToFavoriteRequest } from '../model/models';
import { AddUsersToGroupRequest } from '../model/models';
import { CreateGroupRequest } from '../model/models';
import { CreateItemRequest } from '../model/models';
import { CreateSectionRequest } from '../model/models';
import { DownloadSectionFilePdfRequest } from '../model/models';
import { GroupResource } from '../model/models';
import { ItemResource } from '../model/models';
import { SectionResource } from '../model/models';
import { ToggleVisibilitySelectedRequest } from '../model/models';
import { UpdateGroupRequest } from '../model/models';
import { UpdateItemOrderRequest } from '../model/models';
import { UpdateItemRequest } from '../model/models';
import { UpdateSectionRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CurrentEventsServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Add or remove model to favorite list
     * 
     * @param addOrRemoveModelToFavoriteRequest 
     */
    addOrRemoveModelToFavorite(addOrRemoveModelToFavoriteRequest?: AddOrRemoveModelToFavoriteRequest, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Add users to group
     * 
     * @param id 
     * @param addUsersToGroupRequest 
     */
    addUsersToGroup(id: string, addUsersToGroupRequest?: AddUsersToGroupRequest, extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Saves new group to database
     * 
     * @param createGroupRequest 
     */
    createNewGroup(createGroupRequest?: CreateGroupRequest, extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Saves new item to database
     * 
     * @param createItemRequest 
     */
    createNewItem(createItemRequest?: CreateItemRequest, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Saves new section to database
     * 
     * @param createSectionRequest 
     */
    createNewSection(createSectionRequest?: CreateSectionRequest, extraHttpRequestParams?: any): Observable<SectionResource>;

    /**
     * Deletes group with given by ID
     * 
     * @param id 
     */
    deleteGroup(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Deletes item with given by ID
     * 
     * @param id 
     */
    deleteItem(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Deletes section with given by ID
     * 
     * @param id 
     */
    deleteSection(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Download PDF for section file
     * 
     * @param id 
     * @param downloadSectionFilePdfRequest 
     */
    downloadSectionFilePdf(id: string, downloadSectionFilePdfRequest?: DownloadSectionFilePdfRequest, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Duplicate item
     * Duplicate an item with all its sections and planners
     * @param id Item ID
     */
    duplicateItem(id: number, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Duplication group with given by ID
     * 
     * @param id 
     */
    duplicationGroup(id: string, extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Get all events
     * 
     */
    getAllEvents(extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Find event by given ID
     * 
     * @param id 
     */
    getEventById(id: string, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Remove user from item
     * 
     * @param id 
     * @param userId 
     */
    removeUserFromItem(id: string, userId: string, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Toggle visibility for selected users
     * 
     * @param id 
     * @param toggleVisibilitySelectedRequest 
     */
    toggleVisibilitySelected(id: string, toggleVisibilitySelectedRequest?: ToggleVisibilitySelectedRequest, extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Updates an existing group
     * 
     * @param id 
     * @param updateGroupRequest 
     */
    updateGroup(id: string, updateGroupRequest?: UpdateGroupRequest, extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Updates an existing item
     * 
     * @param id 
     * @param updateItemRequest 
     */
    updateItem(id: string, updateItemRequest?: UpdateItemRequest, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Updates order for items
     * 
     * @param updateItemOrderRequest 
     */
    updateItemOrder(updateItemOrderRequest?: UpdateItemOrderRequest, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Updates order for sections
     * 
     * @param updateItemOrderRequest 
     */
    updateOrder(updateItemOrderRequest?: UpdateItemOrderRequest, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Updates an existing section
     * 
     * @param id 
     * @param updateSectionRequest 
     */
    updateSection(id: string, updateSectionRequest?: UpdateSectionRequest, extraHttpRequestParams?: any): Observable<SectionResource>;

}
